import React from 'react';
import cn from 'classnames';

// components
import { AdminGroupSessionItem } from '../../items';
// style
import '../../style.scss';

const SessionList: React.FC<any> = ({ sessions }: any) => {
  return (
    <div className={cn('session-list', { content: sessions.next.length || sessions.future.length })}>
      <div className="session-list__next">
        <div className="session-list__label">Next Group Session</div>
        {sessions.next.length === 0 && <span>This group has not had a session</span>}
        <div className="session-list__items">{sessions && <SessionListNext items={sessions.next} />}</div>
      </div>
      <div className="session-list__next">
        <div className="session-list__label">Future Sessions</div>
        {sessions.future.length === 0 && <span>This group does not have future sessions</span>}
        <div className="session-list__items">{sessions && <SessionListFuture items={sessions.future} />}</div>
      </div>
    </div>
  );
};

export default SessionList;

export const SessionListNext: React.FC<any> = ({ items }: any) => {
  return (
    <div className="session-list__items">
      {items &&
        items.map((item: any) => {
          return <AdminGroupSessionItem key={item.id} item={item} />;
        })}
    </div>
  );
};

export const SessionListFuture: React.FC<any> = ({ items }: any) => {
  return (
    <div className="session-list__items">
      {items &&
        items.map((item: any) => {
          return <AdminGroupSessionItem key={item.id} item={item} />;
        })}
    </div>
  );
};
